export default __webpack_public_path__ + "sounds/c26200c6c6eb4b853fe0e107d59f3c9f.mp3";